/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  PostApiRolesApiBodies,
  PutApiRolesIdApiBodies,
  RoleAttributesApiDTO,
  UserApiDTO
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




export const getApiRoles = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<RoleAttributesApiDTO[]>(
      {url: `/api/roles`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiRolesQueryKey = () => {
    return [`/api/roles`] as const;
    }

    
export const getGetApiRolesQueryOptions = <TData = Awaited<ReturnType<typeof getApiRoles>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiRoles>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRolesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRoles>>> = ({ signal }) => getApiRoles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRoles>>>
export type GetApiRolesQueryError = ErrorType<unknown>

export const useGetApiRoles = <TData = Awaited<ReturnType<typeof getApiRoles>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiRoles>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiRolesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiRoles = (
    postApiRolesApiBodies: PostApiRolesApiBodies,
 ) => {
      
      
      return customInstance<RoleAttributesApiDTO>(
      {url: `/api/roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiRolesApiBodies
    },
      );
    }
  


export const getPostApiRolesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRoles>>, TError,{data: PostApiRolesApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiRoles>>, TError,{data: PostApiRolesApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRoles>>, {data: PostApiRolesApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiRoles(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiRolesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRoles>>>
    export type PostApiRolesMutationBody = PostApiRolesApiBodies
    export type PostApiRolesMutationError = ErrorType<unknown>

    export const usePostApiRoles = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRoles>>, TError,{data: PostApiRolesApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiRoles>>,
        TError,
        {data: PostApiRolesApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiRolesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiRolesId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RoleAttributesApiDTO>(
      {url: `/api/roles/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiRolesIdQueryKey = (id: string,) => {
    return [`/api/roles/${id}`] as const;
    }

    
export const getGetApiRolesIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiRolesId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiRolesId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRolesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRolesId>>> = ({ signal }) => getApiRolesId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRolesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiRolesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRolesId>>>
export type GetApiRolesIdQueryError = ErrorType<unknown>

export const useGetApiRolesId = <TData = Awaited<ReturnType<typeof getApiRolesId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiRolesId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiRolesIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const putApiRolesId = (
    id: string,
    putApiRolesIdApiBodies: PutApiRolesIdApiBodies,
 ) => {
      
      
      return customInstance<RoleAttributesApiDTO>(
      {url: `/api/roles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putApiRolesIdApiBodies
    },
      );
    }
  


export const getPutApiRolesIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiRolesId>>, TError,{id: string;data: PutApiRolesIdApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiRolesId>>, TError,{id: string;data: PutApiRolesIdApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiRolesId>>, {id: string;data: PutApiRolesIdApiBodies}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiRolesId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiRolesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiRolesId>>>
    export type PutApiRolesIdMutationBody = PutApiRolesIdApiBodies
    export type PutApiRolesIdMutationError = ErrorType<unknown>

    export const usePutApiRolesId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiRolesId>>, TError,{id: string;data: PutApiRolesIdApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiRolesId>>,
        TError,
        {id: string;data: PutApiRolesIdApiBodies},
        TContext
      > => {

      const mutationOptions = getPutApiRolesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteApiRolesId = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/roles/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApiRolesIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiRolesId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiRolesId>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiRolesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiRolesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiRolesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiRolesId>>>
    
    export type DeleteApiRolesIdMutationError = ErrorType<unknown>

    export const useDeleteApiRolesId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiRolesId>>, TError,{id: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiRolesId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiRolesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiRolesIdUsers = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserApiDTO[]>(
      {url: `/api/roles/${id}/users`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiRolesIdUsersQueryKey = (id: string,) => {
    return [`/api/roles/${id}/users`] as const;
    }

    
export const getGetApiRolesIdUsersQueryOptions = <TData = Awaited<ReturnType<typeof getApiRolesIdUsers>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiRolesIdUsers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRolesIdUsersQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRolesIdUsers>>> = ({ signal }) => getApiRolesIdUsers(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRolesIdUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiRolesIdUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRolesIdUsers>>>
export type GetApiRolesIdUsersQueryError = ErrorType<unknown>

export const useGetApiRolesIdUsers = <TData = Awaited<ReturnType<typeof getApiRolesIdUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiRolesIdUsers>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiRolesIdUsersQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



